import clsx from "clsx"

import { Badge } from "@atoms"

import GroupLabel from "@molecules/GroupLabel/GroupLabel"

import styles from "./SelectListGroupLabel.module.scss"
import { SelectListGroupLabelProps } from "./SelectListGroupLabel.types"

export default function SelectListGroupLabel(props: SelectListGroupLabelProps) {
    const { variant, className, prefixSlot, title, showBadge, badge, isLoading = false, ...rest } = props

    const suffixSlot =
        showBadge && badge ? (
            <Badge size="sm" variant="default">
                {badge}
            </Badge>
        ) : null

    const groupLabelProps = { label: title, suffixSlot, isCollapsible: false, isLoading }

    return (
        <div className={clsx(styles.base, className)} {...rest}>
            {variant === "primary" ? (
                <GroupLabel {...groupLabelProps} variant="primary" prefixSlot={prefixSlot} showMiddleSlot={false} />
            ) : (
                <GroupLabel {...groupLabelProps} variant="secondary" />
            )}
        </div>
    )
}
